(function () {
  'use strict';

  /* ── Cart count sync ───────────────────────────────────────────────────── */

  function syncCartCount(count) {
    document.querySelectorAll('.header-cart-count').forEach(function (el) {
      el.textContent = count > 0 ? '(' + count + ')' : '';
    });
  }

  function fetchCartCount() {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { syncCartCount(cart.item_count); })
      .catch(function () {});
  }

  /* ── Toast ─────────────────────────────────────────────────────────────── */

  var toastTimer = null;
  function showToast(msg) {
    var toast = document.getElementById('cart-toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  /* ── Quick Add ─────────────────────────────────────────────────────────── */

  document.querySelectorAll('.product-card__quick-add').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var id = parseInt(btn.dataset.variantId, 10);
      if (!id || btn.disabled) return;

      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = '—';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          btn.textContent = 'Added';
          btn.classList.add('is-added');
          fetchCartCount();
          showToast('Added to cart');
          setTimeout(function () {
            btn.textContent = original;
            btn.classList.remove('is-added');
            btn.disabled = false;
          }, 1600);
        })
        .catch(function () {
          btn.textContent = original;
          btn.disabled = false;
        });
    });
  });

  /* ── Init cart count on page load ──────────────────────────────────────── */
  fetchCartCount();

})();
